//
import * as React from 'react';

import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MuiSelect from '@mui/material/Select';

import { getIn } from 'formik';

// would be nice if we could exclude following props, not sure how or if we can in flow
//   form, checked, defaultChecked, name, onChange, value

export const fieldToSelect = ({ field, form, disabled = false, ...props }) => {
  const { name } = field;
  const { touched, errors, isSubmitting } = form;

  const fieldError = getIn(errors, name);
  // note, the form.submitCount is required to fix empty field not being returned in touched when submitting
  const showError = (getIn(touched, name) || form.submitCount > 0) && !!fieldError;

  return {
    ...props,
    ...field,
    error: showError,
    helperText: showError ? fieldError : props.helperText,
    disabled: isSubmitting || disabled,
  };
};

const handleChange = (onChange, onFieldChange) => (e, child) => {
  onChange(e);

  if (onFieldChange) {
    onFieldChange(e, child);
  }
};

const FormikSelect = (props) => {
  const { children, error, helperText, name, onBlur, onChange, onFieldChange, SelectProps, value, ...other } =
    fieldToSelect(props);
  return (
    <FormControl error={error} {...other}>
      <MuiSelect
        {...SelectProps}
        name={name}
        onBlur={onBlur}
        onChange={handleChange(onChange, onFieldChange)}
        value={value ?? ''}
      >
        {children}
      </MuiSelect>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

FormikSelect.displayName = 'FormikSelect';
export default FormikSelect;
